<template>
 <div class="infomation main_top">
    <div class="">
        <br>
        <br>
        <h1>Anti-Money Laundering (AML) Policy</h1>
        <br>
        <p>1.Policy StatementHug Gifts ("the Company"), a U.S.-centric e-commerce platform specializing in the authorized distribution of in-game virtual currency and items, is dedicated to combating money laundering (ML), terrorist financing (TF), and other financial crimes. This AML Policy aligns with relevant U.S. legislation, including the Bank Secrecy Act and PATRIOT Act, ensuring robust due diligence, transaction monitoring, and reporting procedures tailored to the U.S. market.</p>
        <br>
        <p>2.Compliance Framework</p>
        <ul>
            <li>Compliance Oversight: A designated AML Compliance Officer, reachable at info@huggifts.com, is responsible for executing this policy.</li>
            <li>Third-Party Partnerships: The Company collaborates with licensed payment processors for transaction settlement, utilizing their advanced AML/KYC systems to enhance risk management across the U.S. market.</li>
        </ul>
        <br>
        <p>3.Customer Due Diligence (CDD)</p>
        <ul>
            <li>Sub-Merchant Onboarding: For all sub-merchants (predominantly U.S.-based), Hug Gifts performs CDD by confirming: </li>
            <p>Legal entity registration and Ultimate Beneficial Owner (UBO) identification (limited to natural persons or direct legal entities, excluding trusts or nominees). </p>
            <p>Business alignment with Hug Gifts’ in-game item marketplace.</p>
            <li>Player Identity Verification: Players undergo due diligence during game account registration, managed by our game partner, BigPlayer. Hug Gifts retrieves and validates player identity data through BigPlayer’s API verification interface, ensuring consistency with sub-merchant-submitted details and improving traceability within the U.S. </li>
            <li>Enhanced Due Diligence (EDD): High-risk sub-merchants (e.g., those engaged in cross-border operations or high transaction volumes) are subject to EDD, including additional identity checks and cross-referencing of player behavior data and transaction patterns via BigPlayer’s API.</li>
        </ul>
        <br>
        <p>4. Risk Assessment & Transaction Monitoring</p>
        <ul>
            <li>Risk Profiling: Sub-merchants are assessed and categorized based on geographic risk, transaction trends, and exposure to sanctioned regions (e.g., OFAC-listed countries), with a focus on U.S.-specific risks. </li>
            <li>Monitoring Mechanisms: Internal systems identify suspicious transactions (e.g., atypical frequency, value, or patterns deviating from standard in-game item sales). The compliance team conducts prompt reviews and investigations of flagged activities.</li>
        </ul>
        <br>
        <p>5.Reporting & Record-Keeping</p>
        <ul>
            <li>Suspicious Activity Reporting: The Compliance Officer submits reports on suspicious activities to relevant U.S. authorities (e.g., FinCEN) within mandated timelines (typically 24–48 hours). </li>
            <li>Record Retention: CDD documentation, transaction records, and reports are securely maintained for at least five years, readily available for audits or regulatory inspections.</li>
        </ul>
        <br>
        <p>6.Training & Audits</p>
        <ul>
            <li>Staff Development: Mandatory annual AML/TF training is provided to employees involved in sub-merchant onboarding and transaction oversight, focusing on identifying red flags, CDD processes, and reporting duties, tailored to U.S. regulations.</li>
            <li>Internal Audits: Bi-annual evaluations of AML procedures guarantee alignment with current U.S. regulations and operational efficacy, reflecting updates as of 2025.</li>
        </ul>
        <br>
        <p>7.Policy Updates</p>
        <br>
        <p>This AML Policy undergoes an annual review or is revised upon significant regulatory or business developments (e.g., market expansion within the U.S.). The most current version will be published at https://huggifts.com/aml-policy and disseminated to all stakeholders.</p>
        <br>
        <p>Disclaimer: This policy is customized for HugGifts’ role as a U.S.-based online retailer of in-game items, designed to meet regulatory standards. For comprehensive compliance, engage a legal expert to address U.S.-specific regulations. Submit this policy as hyperlink it on website for regulatory evaluation.</p>
    </div>
    
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>